// @flow

// Types
import type {
  SoilJob,
} from 'hfty-model-soil-jobs/types'

// Libs
import { createSelector } from 'reselect'
import _map from 'lodash/map'

// Utils
import traverse from 'fc-utils/traverse'
import emptyArrayOr from 'fc-utils/emptyArrayOr'

// Constants
import { TREE, BRANCH } from '../constants'

export default createSelector(
  [traverse([TREE, BRANCH])],
  function (jobs: { [number]: SoilJob }): Array<SoilJob> {
    return emptyArrayOr(_map(jobs))
  }
)
